// extracted by mini-css-extract-plugin
module.exports = {"main":"Notification-module__main--FkQUQ","failed":"Notification-module__failed--1iSdu","text":"Notification-module__text--1BNtA"};